import { AnyAction } from "redux";
import { AppState } from "../store";

import VideoFiles from "./VideoFiles";
import SessionConfig from "./SessionConfig";
import GetReady from "./GetReady";

export interface StepDefinition {
    (x: AppState, y: React.Dispatch<AnyAction>): {
        name: string
        label: string
        content: JSX.Element
    }
} 

const steps: StepDefinition[] = [VideoFiles, SessionConfig, GetReady]

export default steps